import request from '@/api/request'
/**
 * 获取人才服务列表
 * @param page
 * @param limit
 */
export const getTalentServeListPage = (params) => {
  return request({
    url: 'radioweb/app/web/getTalentServeListPage',
    params,
    method: 'get'
  })
}
/**
 * 获取人才服务详情(by Type)
 */
export const getTalentServeByType = (params) => {
  return request({
    url: 'radioweb/app/talentServe/getTalentServeByType',
    params,
    method: 'get'
  })
}
/**
 * 获取人才服务详情
 */
export const getTalentServe = (params) => {
  return request({
    url: 'radioweb/app/talentServe/getTalentServe',
    params,
    method: 'get'
  })
}
/**
 * 提交联系方式
 */
export const addMessageBoard = (data) => {
  return request({
    url: 'radioweb/app/messageBoard/addMessageBoard',
    data,
    method: 'post'
  })
}
